module.exports = __webpack_public_path__ + "img/rar.3d1a536f.png";